export default __webpack_public_path__ + "static/media/A&BKhata.1f456198.png";